import React from "react"
import {Box, Button, Stack, Typography, useTheme} from "@mui/joy";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next"
import {Award} from "lucide-react";
import {guestRoute} from "../../utils/routes";


const NoSubscriptionComponent = () => {
    const {t}=useTranslation()

    return <Stack width={"100%"} alignItems={"center"} gap={2} paddingBottom={4} paddingY={2}>
        <Typography>
            <Award style={{color:"inherit", fontSize:90}}/>
        </Typography>

        <Stack alignItems={"center"}>
            <Typography level={"h3"}>
                {t("subscriptionPromptTitle")}
            </Typography>
            <Typography level={"body-sm"} fontWeight={"normal"}>
                {t("subscriptionPromptDescription")}
            </Typography>
        </Stack>

        {/* On the app subdomain pricing lives on the main site, so it's a full link there. */}
        {guestRoute("/pricing").startsWith("http") ?
            <Button size={"lg"} variant={"outlined"} component={"a"} href={guestRoute("/pricing")}>
                {t("viewPricingActionButtonLabel")}
            </Button> :
            <Button size={"lg"} variant={"outlined"} component={Link} to={guestRoute("/pricing")}>
                {t("viewPricingActionButtonLabel")}
            </Button>}
    </Stack>
}

export default NoSubscriptionComponent